import React, {useState, useEffect} from 'react'
import { MainLayout } from "../../../layout/MainLayout";
import { Button } from "../../../components/client/Button/Button";
import { Link } from "react-router-dom";
import {HOST} from '../../../config';

export default function Home() {
    const [data, setData] = useState([]);

    useEffect(() => {
        const requestOptions = {
            method: 'GET',
            redirect: 'follow'
          };
          
          fetch(`${HOST}/exam`, requestOptions)
            .then(response => response.text())
            .then(result => {
                const res = JSON.parse(result);
                setData(res);
                console.log(res)
            })
            .catch(error => console.log('error', error));
    }, [])
  return (
    <MainLayout>
      <div className="grid grid-cols-1">
        <div>
          <p className="mb-1 font-bold">
            Thi sát hạch lý thuyết lái xe online
          </p>
          <p className="mb-1">
            Dựa trên tài liệu luyện thi lý thuyết lái xe của Tổng Cục Đường Bộ
            Việt Nam, VnExpress giới thiệu trang trắc nghiệm luật giao thông
            mới nhất với 60 đề thi cho bằng B2, gồm 600 câu hỏi.
          </p>
          <p className="mb-1">
            Đề ôn luyện không nhất thiết trùng với đề thi thực tế.
          </p>
          <p className="mb-1">
            Hãy chọn một trong 60 đề để bắt đầu thi. Mỗi câu hỏi có thể có
            nhiều hơn một đáp án đúng.
          </p>
          <p className="mb-1">Làm đúng 32/35 câu trở lên thì Đạt.</p>
          <p className="mb-1">
            Mỗi đề thi có 1 câu hỏi điểm liệt, nếu làm sai câu điểm liệt, bài
            thi Không đạt.
          </p>
          <p className="mb-1">Thời gian làm bài 22 phút.</p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 mt-3">
          {data.map((item, key) => {
            return (
              <div key={key} className="flex justify-between items-center border-[1px] bg-[#f5f5f5] p-1">
                <p>Đề {item.name}</p>
                <Button className="min-w-[40px]" onClick={() => {}}>
                <Link to={'/exam/' + item.id}>Thi thử</Link>
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </MainLayout>
  );
}
